interface ILabyData {
    version_app: string;
    version_donnees: string;
    titre: string;
    textes:{
        popup_intro:string; 
        popup_intro_infoplus:string;
        popup_quitter:string;
        popup_quitter_btn_rester:string;
        popup_quitter_btn_quitter:string;
    };
    labyrinthes:Array<ILabyrinthe>
}

export interface ILabyUrlParams{
    debug?:string;
    debugmov?:string;
    debugdecl?:string;
    debugquest?:string;
    niveau?:string;
    ecus_niveau?:string;
    position?:string;
    question?:string;
}


export interface ILabyrinthe{
    id:number;
    matrice_deplacement:IMatriceLaby;
    matrice_torches:IMatriceLaby;
    matrices_questions:Array<IMatriceQuestion>;
    questions:Array<IQuestion>;
}

export interface IMatriceLaby{    
    ligneA:String;
    ligneB:String;
    ligneC:String;
    ligneD:String;
    ligneE:String;
    ligneF:String;
    ligneG:String;
    ligneH:String;
    ligneI:String;
    ligneJ:String;
}

export interface IMatriceQuestion{    
    matrice_declencheurs:IMatriceLaby;
    matrice_questions:IMatriceLaby;
}

export interface IQuestion{
    id:string;
    instruction:string;
    phrase?:string;
    choixA:string;
    choixB:string;
    choixC?:string;
    choixD?:string;
    reponse:string;
}


export type DirectionLitterale = "GAUCHE" | "HAUT" | "BAS" | "DROITE";
export type CodeDeplacement = "0" | "1" | "2" | "3" | "4" | "5" | "6"
| "7" | "8" | "9" | "A" | "B" | "C"| "D" | "E" | "F" | "?";
export type CodeDeclencheur = "0" | "1" | "2" | "3" | "4" | "5" | "6"
| "7" | "8" | "9" | "A" | "B" | "C"| "D" | "E" | "F";
export type CodeQuestions = "0" | "1" | "2" | "3" | "4" | "5" | "6"
| "7" | "8" | "9" | "A" | "B" | "C"| "D" | "E" | "F";
export type CodesChoix = "A" | "B" | "C" | "D";
export const ListeCodesChoix:Array<CodesChoix> = ["A", "B", "C", "D"];

export const CodeDeplacementListe = ["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F"];
export const CodeDeclencheurListe = ["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F"];
export const CodeQuestionListe = ["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F"];


export interface ICoffreHud{
    code:string;
    etat:ICoffreHudEtat;
    valeur:number;
}
export type ICoffreHudEtat = "closed" | "active" | "opened" | "missed" | "timedout";

export type IPopupType = "question" | "quitter" | "fin_partie" | "";

export interface IPopupQuestionBaseInfo{
    valeur:number;
    code:CodeQuestions;
}
export interface IPopupFinPartieBaseInfo{
    valeur:number;
    niveau:number;
}

export type listeDeQuestions = Array<string>;

export default ILabyData;